import(/* webpackMode: "eager" */ "/vercel/path0/src/app/product-center/[id]/[slug]/DataShow.tsx")